export default __webpack_public_path__ + "static/media/mark-complete.77f2ca75.svg";